/**
 * Created by Bart Decorte
 * Date: 04/10/2018
 * Time: 19:05
 */
import 'jquery';
import { url } from './api';

class Request {
  constructor(endpoint, method, data = {}) {
    this.endpoint = endpoint;
    this.method = method;
    this.data = data;
    this.options = {
      headers: {
        'X-CSRF-TOKEN': esign.info.csrf,
        Accept: 'application/json',
      },
      type: this.method,
      url: this.url(),
      data: this.data,
      dataType: 'json',
      processData: true,
    };
  }

  url() {
    return url(this.endpoint);
  }

  execute(options = {}) {
    let { headers, ...requestOptions } = options;
    requestOptions.headers = { ...this.options.headers, ...headers };
    requestOptions = { ...this.options, ...requestOptions };
    return $.ajax(requestOptions);
  }
}

export default Request;



// WEBPACK FOOTER //
// ./resources/assets/js/utils/Request.js